mutation CalculateGiveawayWinners($giveawayId: ID!) {
  giveaway: StreamToolsCalculateGiveawayWinners(giveawayId: $giveawayId) {
    giveawayId
    status
    entrantCount
    hasDraw
    startedAt
    closedAt
    publishedAt
    version
    winners {
      login
      displayName
      rank
      kind
    }
    draw {
      drawId
      methodVersion
      eligibleCount
      targetRound
      fallbackUsed
      drawnAt
      shortPool
      requestedWinnerCount
      requestedAlternateCount
      winners {
        twitchUserId
        login
        displayName
        rank
        kind
        disqualifiedAt
        disqualifiedReason
      }
      alternates {
        twitchUserId
        login
        displayName
        rank
        kind
        disqualifiedAt
        disqualifiedReason
      }
      disqualifications {
        twitchUserId
        reason
        byUserId
        at
        promotedTwitchUserId
      }
    }
  }
}
